import { Route } from 'vue-router';
import { Context } from '@nuxt/types/app';

export default ({ app }: Context) => {
  if (app.router) {
    // Every time the route changes (fired on initialization too)
    app.router.afterEach((_to: Route, from: Route) => {
      if (from.path && from.path === '/') {
        if (app.store) {
          setInternalRouting(false, app.store.state);
        }
      } else {
        if (app.store) {
          setInternalRouting(true, app.store.state, from.path);
        }
      }
    });
  }
};

function setInternalRouting(setInternal: boolean, store: any, route: string = '') {
  store.internalRouting = setInternal ? route : false;
}
